export default {
    USER_NOTIFICATIONS: 'userNotifications',
    LAUNCHED_REPORTS: 'launchedReports',
    UPLOADED_DOCUMENTS: 'uploadedDocuments',
    SECURE_UPLOAD_DOCUMENTS: 'secureUploadDocuments'
};
